import BUYING_SESSION_PRODUCT from './buyingSessionProducts.graphql'

import WS_BUYING_SESSION_PRODUCTS from './buyingSessionProducts.graphql'

export { BUYING_SESSION_PRODUCT, WS_BUYING_SESSION_PRODUCTS }
